const GlobalComponentsPlugin = {
  install(app) {
    app.component('IButton', () => import('@/components/ui/i-button'));
    app.component('IFormItem', () => import('@/components/ui/i-form-item'));
    app.component('IButtonIconText', () => import('@/components/ui/i-button-icon-text'));
    app.component('IUserAvatar', () => import('@/components/ui/i-user-avatar'));
    app.component('IBadge', () => import('@/components/ui/i-badge'));
    app.component('IInfoListItem', () => import('@/components/ui/i-info-list-item'));
    app.component('IConfirmPopover', () => import('@/components/ui/i-confirm-popover'));
    app.component('IStepProgress', () => import('@/components/ui/i-step-progress'));
    app.component('IUpload', () => import('@/components/ui/i-upload'));
    app.component('ICollapseItem', () => import('@/components/ui/i-collapse-item'));
  },
};

export default GlobalComponentsPlugin;
